import type { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { UPSERT_WARBOX_MESSAGE } from '../constants/actions';
import type { TWarboxMessageActionTypes } from '../types';

const getErrorMessage = (error: any) =>
    error?.response?.data?.error ||
    (error instanceof Error ? error.message : 'No se pudo actualizar la nota');

export const updateNoteMessage = async (
    dispatch: Dispatch<TWarboxMessageActionTypes>,
    messageId: string,
    message: string
): Promise<void> => {
    const text = message.trim();

    if (!text) {
        throw new Error('Errors.CannotSendWsp');
    }

    try {
        const response = await ApiV2.put(
            `/conversation-messages/${messageId}/update`,
            { message: text },
            HEADERS()
        );

        const updatedMessage = response.data?.data;

        if (updatedMessage) {
            dispatch({
                type: UPSERT_WARBOX_MESSAGE,
                payload: updatedMessage,
            });
        }
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
